import { createSelectionContext } from "@tlc/ls2pac/components/selection/SelectionProvider";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";


export const {
    SelectionProvider: HoldsSelectionProvider, 
    useSelection: useHoldsSelection
} = createSelectionContext<HostSystemItemView>();